export default __webpack_public_path__ + "static/media/imgDark3.7a5db342.png";